import { formatMoneyByCurrency } from '@/utils';
import { StyledTokenIcon } from '@/components/ui/common/TokenIcon';
import { Box } from '@mui/material';
import { isRelease } from '@/utils/checkRuntime';
import { styled } from '@mui/material/styles';
import { getDecimal } from '@/constants/decimal';

const Wrapper = styled(Box)`
  white-space: nowrap;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  display: inline-flex;
  align-items: center;
  gap: 0.3em;
  line-height: 1;
`;

const MoneyWithCurrencyIcon = (
  props: Parameters<typeof formatMoneyByCurrency>[1] & {
    value: any;
  },
) => {
  const { value, currency = 'USDT', ...rest } = props;
  return (
    <Wrapper component={'span'}>
      {formatMoneyByCurrency(value, {
        currency,
        decimal: getDecimal(currency, value),
        ...rest,
      })}
      <StyledTokenIcon currency={currency} fontSize='inherit'/>
    </Wrapper>
  );
};

export default MoneyWithCurrencyIcon;
